import { render, staticRenderFns } from "./AttributeFilter.vue?vue&type=template&id=0d871c4a&scoped=true&"
import script from "./AttributeFilter.vue?vue&type=script&lang=js&"
export * from "./AttributeFilter.vue?vue&type=script&lang=js&"
import style0 from "./AttributeFilter.vue?vue&type=style&index=0&id=0d871c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d871c4a",
  null
  
)

export default component.exports